var symphony = symphony || {};

;(function() {

    symphony.utagLinkClicked = false;
    symphony.utagFormSubmitted = false;
	symphony.utagEvents = function() {

        $('body').on('click', '*:not(.donateHeader-amounts) > a[href*="give.salvationarmy"]:not(.rowDonate-btn):not(.js-donateHeader)', function(e){
            if (typeof utag != 'undefined') {
                e.preventDefault();
                var $elm = $(this);

                var linkTxt = $.trim($(this).text());
                var amt = UTIL.GetQueryStringParameterByName('amount', $(this).attr('href'));
                if (typeof amt == "undefined" || amt == undefined || amt == null || amt == "" || amt == "Other") {
                    amt = UTIL.GetQueryStringParameterByName('amt', $(this).attr('href'));
                }
                if (typeof amt == "undefined" || amt == undefined || amt == null || amt == "" || amt == "Other") {
                    amt = '';
                }
                var btnLocation = $(this).data('btnlocation');
                if (typeof btnLocation == "undefined" || btnLocation == undefined || btnLocation == null || btnLocation == "") {
                    btnLocation = $(this).parents('*[class]').attr('class');
                    if (btnLocation.indexOf('hero') > -1) {
                        btnLocation = 'theater space';
                    }
                }
                utag.link({
                    'event_name' : 'Donate', //Event Name
                    'link_text' : linkTxt, //Link Text
                    'page_name' : utag_data.page_name, //Page Name
                    'site_section' : utag_data.site_section, //Site Section
                    'site_type' : utag_data.site_type, //Site Typelts
                    'territory_division' : utag_data.territory_division, //Site Typelts
                    'login_status' : 'Not Logged In', //Login Status ID
                    'event_type' : 'donate', //Event Typee
                    'donation_amount' : amt, //Donation Amount
                    'button_location' : btnLocation // Location or section of the Donate button on the page
                }, function() {
                    setTimeout(function() {
                        if ($elm.attr('target') && $elm.attr('target') == '_blank') {
                            window.open($elm.attr('href'));
                        } else {
                            location.assign($elm.attr('href'));
                        }
                    }, 600);
                });
            }
        });
        
        $('body').on('click', '*:not(.donateHeader-amounts) > a[href*="satruck.org"]:not(.rowDonate-btn):not(.js-donateHeader)', function(e){
            if (typeof utag != 'undefined') {
                e.preventDefault();
                var $elm = $(this);

                var linkTxt = $.trim($(this).text());
                var btnLocation = $(this).data('btnlocation');
                if (typeof btnLocation == "undefined" || btnLocation == undefined || btnLocation == null || btnLocation == "") {
                    btnLocation = $(this).parents('*[class]').attr('class');
                    if (btnLocation.indexOf('hero') > -1) {
                        btnLocation = 'theater space';
                    }
                }
                utag.link({
                    'event_name' : 'Donate', //Event Name
                    'link_text' : linkTxt, //Link Text
                    'page_name' : utag_data.page_name, //Page Name
                    'site_section' : utag_data.site_section, //Site Section
                    'site_type' : utag_data.site_type, //Site Typelts
                    'territory_division' : utag_data.territory_division, //Site Typelts
                    'login_status' : 'Not Logged In', //Login Status ID
                    'event_type' : 'donate_goods', //Event Typee
                    'button_location' : btnLocation // Location or section of the Donate button on the page
                }, function() {
                    setTimeout(function() {
                        if ($elm.attr('target') && $elm.attr('target') == '_blank') {
                            window.open($elm.attr('href'));
                        } else {
                            location.assign($elm.attr('href'));
                        }
                    }, 600);
                });
            }
        });

        $('body').on('submit', 'form[action*="satruck.org"]', function(e) {
            if (typeof utag != 'undefined') {
                if (symphony.utagFormSubmitted) {
                    symphony.utagFormSubmitted = false;
                    return;
                }

                e.preventDefault();
                var $elm = $(this);
                
                var btnLocation = $(this).data('btnlocation');
                var pagename = utag_data.page_name;
                if (typeof btnLocation == "undefined" || btnLocation == undefined || btnLocation == null || btnLocation == "") {
                    btnLocation = $(this).parents('*[class]').attr('class');
                    if (btnLocation.indexOf('hero') > -1) {
                        btnLocation = 'theater space';
                    } else if ($elm.parents('.donateHeader').length > 0) {
                        btnLocation = 'Header_Modal';
                        pagename = utag_data.territory_division + ' | modal:donate';
                    }
                }
                utag.link({
                    'event_name' : 'Donate', //Event Name
                    'link_text' : 'Donate Goods Button', //Link Text
                    'page_name' : pagename, //Page Name
                    'site_section' : utag_data.site_section, //Site Section
                    'site_type' : utag_data.site_type, //Site Typelts
                    'territory_division' : utag_data.territory_division, //Site Typelts
                    'login_status' : 'Not Logged In', //Login Status ID
                    'event_type' : 'donate_goods', //Event Typee
                    'button_location' : btnLocation // Location or section of the Donate button on the page
                }, function() {
                    setTimeout(function() {
                        symphony.utagFormSubmitted = true;
                        $elm.submit();
                    }, 600);
                });
            }
        });

        $('body').on('click', '.at-share-btn-elements a', function(e) {
            if (typeof utag != 'undefined') {
                if (symphony.utagLinkClicked) {
                    symphony.utagLinkClicked = false;
                    return;
                }

                e.preventDefault();
                var $elm = $(this);

				utag.link({
					'event_name' : 'Social Aware', //Event Name
					'link_text' : 'Submit', //Link Text
					'page_name' : utag_data.page_name,//Page Name
					'site_section' : utag_data.site_section, //Site Section
					'site_type' : 'SAL:' + symphonyTerritory, //Site Type
					'login_status' : 'Not Logged In', //Login Status
					'event_type' : 'social_share', //Event Type
					'article_title' : typeof utag_data.article_title != 'undefined' ? utag_data.article_title : '',//Newsroom Article title
					'article_author' : typeof utag_data.article_author != 'undefined' ? utag_data.article_author : '', //Newsroom Article Author
					'share_type' : $(this).text(), //Social Share button which is beingclicked
					'button_location' : $(this).parents('.addthis_sharing_toolbox').prev('*[data-btnlocation]').eq(0).data('btnlocation') //Location or section of the SocialShare buttons on the page
				}, function() {
                    symphony.utagLinkClicked = true;
                    $elm.trigger('click');
                });
			}
        });

        $('body').on('click', '.socialMedia-container a', function(e) {
            if (typeof utag != 'undefined') {
                e.preventDefault();

                var link = $(this).attr('href');
                var target = $(this).attr('target');
                var share_type = 'facebook';
                if (link.indexOf('facebook') > -1) { share_type = 'facebook'; }
                else if (link.indexOf('twitter') > -1) { share_type = 'twitter'; }
                else if (link.indexOf('instagram') > -1) { share_type = 'instagram'; }
                else if (link.indexOf('pinterest') > -1) { share_type = 'pinterest'; }
                else if (link.indexOf('youtube') > -1) { share_type = 'youtube'; }
                else if (link.indexOf('vimeo') > -1) { share_type = 'vimeo'; }

				utag.link({
					'event_name' : 'Social Aware', //Event Name
					'link_text' : 'Submit', //Link Text
					'page_name' : utag_data.page_name,//Page Name
					'site_section' : utag_data.site_section, //Site Section
					'site_type' : 'SAL:' + symphonyTerritory, //Site Type
					'login_status' : 'Not Logged In', //Login Status
					'event_type' : 'social_share', //Event Type
					'article_title' : typeof utag_data.article_title != 'undefined' ? utag_data.article_title : '',//Newsroom Article title
					'article_author' : typeof utag_data.article_author != 'undefined' ? utag_data.article_author : '', //Newsroom Article Author
					'share_type' : share_type, //Social Share button which is being clicked
					'button_location' : 'footer' //Location or section of the SocialShare buttons on the page
				}, function() {
                    setTimeout(function() {
                        if (target && target == '_blank') {
                            window.open(link);
                        } else {
                            location.assign(link);
                        }
                    }, 600);
                });
			}
        });

    };
    
    symphony.utagViewCount = 0;
    symphony.utagView = function(d, fireView) {
        fireView = typeof fireView == "undefined" ? true : fireView;
        if (typeof utag != "undefined" && typeof utag_data != "undefiend" && symphony.utagViewCount < 50) {
            symphony.utagViewCount = 0;
            utag_data = $.extend(utag_data, d);
            if (fireView) {
                utag.view(utag_data);
            }
        } else {
            symphony.utagViewCount++;
            setTimeout(function() { symphony.utagView(d, fireView); }, 300);
        }  
    };


})();